/**
 * GDSTraceabilityContent - GDS追溯完整渲染组件
 * 
 * 包含完整的GDS追溯页面所有元素：
 * - 轮播图
 * - 产品基本信息
 * - 条形码
 * - 认证信息
 * - Tab详细信息
 */

import React from 'react';
import Carousel from '../common/Carousel';
import TabNavigation from '../common/TabNavigation';
import VerificationBadge from '../common/VerificationBadge';
import Barcode from '../common/Barcode';

export default function GDSTraceabilityContent({ data, mode = 'view' }) {
  if (!data) return null;

  // 准备Tab数据
  const prepareTabs = () => {
    if (!data.tabs || data.tabs.length === 0) return [];
    
    return data.tabs.map(tab => ({
      label: tab.label,
      icon: tab.icon,
      content: renderTabContent(tab)
    }));
  };

  // 渲染Tab内容
  const renderTabContent = (tab) => {
    return (
      <div className="gds-tab-content-fields">
        {tab.fields && tab.fields.map((field, index) => (
          <div key={index} className="gds-field-item">
            <div className="gds-field-label">{field.label}</div>
            <div className="gds-field-value">{field.value || '暂无数据'}</div>
          </div>
        ))}
      </div>
    );
  };

  return (
    <div className="label-content-gds-traceability">
      {/* 轮播图区域 */}
      {data.carouselImages && data.carouselImages.length > 0 && (
        <div className="gds-carousel-section">
          <Carousel 
            images={data.carouselImages}
            autoPlay={true}
            interval={4000}
            showControls={true}
            showIndicators={true}
            badge="官方认证"
          />
        </div>
      )}

      {/* 产品基本信息 */}
      <div className="gds-product-basic-info">
        <h2 className="gds-product-name">{data.productName || '产品名称'}</h2>
        <div className="gds-product-meta">
          {data.productCode && (
            <div className="gds-product-code">产品编码：{data.productCode}</div>
          )}
          {data.productionDate && (
            <div className="gds-production-date">生产日期：{data.productionDate}</div>
          )}
        </div>
      </div>

      {/* 条形码展示 */}
      {data.barcodeValue && (
        <div className="gds-barcode-section">
          <Barcode 
            value={data.barcodeValue}
            width={280}
            height={90}
            displayValue={true}
          />
        </div>
      )}

      {/* 认证信息区 */}
      {data.certifications && data.certifications.length > 0 && (
        <div className="gds-certifications-section">
          <h3 className="gds-section-title">
            认证信息
          </h3>
          <div className="gds-certifications-grid">
            {data.certifications.map((cert, index) => (
              <VerificationBadge 
                key={index}
                type={cert.type}
                label={cert.label}
                certified={cert.certified}
                certNumber={cert.certNumber}
                certDate={cert.certDate}
                certOrg={cert.certOrg}
              />
            ))}
          </div>
        </div>
      )}

      {/* Tab详细信息 */}
      {data.tabs && data.tabs.length > 0 && (
        <div className="gds-tabs-section">
          <h3 className="gds-section-title">
            详细信息
          </h3>
          <TabNavigation tabs={prepareTabs()} defaultActiveKey={0} />
        </div>
      )}
    </div>
  );
}

